import {
  GET_REPORT_CONTEXT_DATA,
  GET_REPORT_CONTEXT_DATA_ERROR,
  GET_REPORT_CONTEXT_DATA_SUCCESS,
  GET_REPORT_CONTEXT_DATA_PROGRESS_SUCCESS,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE_ERROR,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE_SUCCESS,
  REPORT_CONTEXT_DATA_WAITING_FOR_CALCULATION,
} from './constants'

export const getReportContextData = ({
  companyCode,
  enableCaching,
  reportId,
}) => ({
  type: GET_REPORT_CONTEXT_DATA,
  companyCode,
  enableCaching,
  reportId,
})
// handleError merges the parsed error, errorType and additionalData into one object and calls this
// with that single object (see ReportDatas' getReportDataError) - reportId/companyCode are read back
// off it rather than destructured up front, so the whole thing survives as `error` for ErrorComponent.
export const getReportContextDataError = (error) => ({
  type: GET_REPORT_CONTEXT_DATA_ERROR,
  companyCode: error?.companyCode,
  error,
  reportId: error?.reportId,
})
export const getReportContextDataSuccess = ({
  companyCode,
  report,
  reportId,
}) => ({
  type: GET_REPORT_CONTEXT_DATA_SUCCESS,
  companyCode,
  report,
  reportId,
})
export const getReportContextDataProgressSuccess = ({
  companyCode,
  progress,
  reportId,
}) => ({
  type: GET_REPORT_CONTEXT_DATA_PROGRESS_SUCCESS,
  companyCode,
  progress,
  reportId,
})

export const reportContextDataWaitingForCalculation = ({
  companyCode,
  reportId,
  companies,
}) => ({
  type: REPORT_CONTEXT_DATA_WAITING_FOR_CALCULATION,
  companyCode,
  reportId,
  // Companies whose actuals are being calculated, as named by the API.
  companies: companies || [],
})
export const invalidateReportContextDataCache = ({
  companyCode,
  reportId,
}) => ({
  type: INVALIDATE_REPORT_CONTEXT_DATA_CACHE,
  companyCode,
  reportId,
})
export const invalidateReportContextDataCacheError = ({
  companyCode,
  error,
}) => ({
  type: INVALIDATE_REPORT_CONTEXT_DATA_CACHE_ERROR,
  error,
  companyCode,
})
export const invalidateReportContextDataCacheSuccess = ({
  companyCode,
  reportId,
}) => ({
  type: INVALIDATE_REPORT_CONTEXT_DATA_CACHE_SUCCESS,
  companyCode,
  reportId,
})
